import { render, staticRenderFns } from "./suppressors.vue?vue&type=template&id=28576777&scoped=true"
import script from "./suppressors.vue?vue&type=script&lang=js"
export * from "./suppressors.vue?vue&type=script&lang=js"
import style0 from "./suppressors.vue?vue&type=style&index=0&id=28576777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28576777",
  null
  
)

export default component.exports